import { Component, computed, inject, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { FormGroup } from '@angular/forms';
import { AbstractNewComponent } from '@unity/abstract/abstract-new.component';
import { CreatedResponseDto, VendorCreateDto, VendorsClient, VendorTypesClient } from '@unity/clients';
import { DropdownControlComponent } from '@unity/forms/dropdown-control/dropdown-control.component';
import { FileUploaderControlComponent } from '@unity/forms/file-uploader-control/file-uploader-control.component';
import { TextboxControlComponent } from '@unity/forms/textbox-control/textbox-control.component';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';
import { ActionCancelSharedComponent } from '@unity/shared/composed/action-cancel-shared/action-cancel-shared.component';
import { ActionSharedComponent } from '@unity/shared/composed/action-shared/action-shared.component';
import { CardNewSharedComponent } from '@unity/shared/composed/card-new-shared/card-new-shared.component';
import { numericFormControl, stringFormControl } from '@unity/utils/form-controls';
import { QuickActions } from '@unity/utils/quick-actions';
import { FormGroupControlSchema, UnityRouteUrlTrees } from '@unity/utils/types';

class VendorCreateSchema implements FormGroupControlSchema<VendorCreateDto> {
  public name = stringFormControl();
  public type_id = numericFormControl();
  public w9_upload_id = numericFormControl();
  public tin = stringFormControl();
}

@Component({
  selector: 'unity-new-vendor-page',
  imports: [
    CardNewSharedComponent,
    PageContainerComponent,
    TextboxControlComponent,
    DropdownControlComponent,
    FileUploaderControlComponent,
    ActionSharedComponent,
    ActionCancelSharedComponent,
  ],
  templateUrl: './new-vendor-page.component.html',
  styleUrl: './new-vendor-page.component.scss',
})
export class NewVendorPageComponent extends AbstractNewComponent<VendorCreateDto, VendorCreateSchema, CreatedResponseDto> {
  private readonly vendorsClient = inject(VendorsClient);
  private readonly vendorTypesClient = inject(VendorTypesClient);

  private readonly vendorTypesResource = rxResource({
    stream: () => this.vendorTypesClient.getAllAsDetailed(),
  });

  protected override readonly $contentHeader = signal('Create New Vendor');

  protected override createResourceFn$ = (form: FormGroup<VendorCreateSchema>) => this.vendorsClient.createOne(form.getRawValue());
  protected override redirectUrlFn = (response: CreatedResponseDto): UnityRouteUrlTrees => ['/vendor', response.id];

  protected override newControlsFn() {
    return new VendorCreateSchema();
  }

  protected readonly $vendorTypes = computed(() => {
    if (!this.vendorTypesResource.hasValue()) {
      return [];
    }
    return this.vendorTypesResource.value().data;
  });
  protected returnToDashboardAction = QuickActions.ReturnToDashboard;
}
